import React, { useState, useEffect } from "react";
import ReactHtmlParser from "react-html-parser";

import api from "../../services/api";
import * as S from "./styles";

const formatDate = (date) => {
  if (!date) return "";

  const inicio = date.substr(0, 10);
  const year = inicio.substr(0, 4);
  const month = inicio.substr(5, 2);
  const day = inicio.substr(-2);

  return `${day}/${month}/${year}`;
};

const AcordionNotification = ({ id, titulo_notificacao, data, texto, visu }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [visualizado, setVisualizado] = useState(visu);

  useEffect(() => {
    setVisualizado(visu);
  }, [visu]);

  const marcarComoVisto = async () => {
    try {
      await api.post(`notificacoes/${id}`);
      setVisualizado(1);
    } catch (error) {}
  };

  const toggleAcordion = () => {
    if (!isOpen && visualizado === 0) {
      marcarComoVisto();
    }
    setIsOpen(!isOpen);
  };

  return (
    <S.Card>
      <S.Header onClick={toggleAcordion}>
        <S.HeaderTexts>
          <S.DateText>{formatDate(data)}</S.DateText>
          <S.Title>{titulo_notificacao}</S.Title>
        </S.HeaderTexts>

        <S.HeaderActions>
          <S.Dot $unread={visualizado === 0} />

          <S.ToggleButton
            type="button"
            $isOpen={isOpen}
            aria-expanded={isOpen}
            aria-label={isOpen ? "Fechar notificação" : "Abrir notificação"}
          >
            <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M3 6L8 11L13 6"
                stroke="#1D2129"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </S.ToggleButton>
        </S.HeaderActions>
      </S.Header>

      <S.Content as="div" $isOpen={isOpen}>
        {ReactHtmlParser(texto)}
      </S.Content>
    </S.Card>
  );
};

export default AcordionNotification;
